export default __webpack_public_path__ + "static/hero@large-95ae09b0a978615768ed0f63f5a247e6.jpg";